<template>

  <v-layout justify-center>
    <template v-if="isAuthenticated">
      <div>
        <img src="../assets/qg-logo_trans-1a.png"/>
        <h1>Welcome to the QGistix Portal</h1>
        <p>Please use the navigation bar on the left to select a report or function.</p>
        <p>(note: you may need to click the <v-icon>mdi-menu</v-icon> icon to open the nav bar)</p>
      </div>
    </template>
    <template v-else>
      <div>
        <img src="../assets/qg-logo_trans-1a.png"/>
        <v-toolbar @click="authenticate()" style="cursor: pointer;">
          <v-toolbar-title>Please click here to log in</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn fab @click="authenticate()">
              <v-icon large>mdi-key</v-icon>
          </v-btn>
        </v-toolbar>
      </div>
    </template>
  </v-layout>

</template>

<script>
  export default {
    name: 'home',
    components: {
    }
    ,methods:
    {
      authenticate ()
      {
        this.$router.push({ name: "login" })
      }
    }
    ,computed: {
      isAuthenticated()
      {
        return this.$store.state.auth.isAuthenticated
      }
    }
  }
</script>
